import * as loadingState from '@dragonfruit/constants/loadingState';

export const REQUEST_LINE_PAY = 'REQUEST_LINE_PAY';
export const REQUEST_LINE_PAY_SUCCESS = 'REQUEST_LINE_PAY_SUCCESS';
export const REQUEST_LINE_PAY_FAILURE = 'REQUEST_LINE_PAY_FAILURE';
export const CHECKOUT_LINE_PAY = 'CHECKOUT_LINE_PAY';
export const CHECKOUT_LINE_PAY_SUCCESS = 'CHECKOUT_LINE_PAY_SUCCESS';
export const CHECKOUT_LINE_PAY_FAILURE = 'CHECKOUT_LINE_PAY_FAILURE';

export const requestLinePay = payload => ({
  type: REQUEST_LINE_PAY,
  payload,
});

export const requestLinePaySuccess = payload => ({
  type: REQUEST_LINE_PAY_SUCCESS,
  payload,
});

export const requestLinePayFailure = errorCode => ({
  type: REQUEST_LINE_PAY_FAILURE,
  payload: {
    errorCode,
  },
});

export const checkoutLinePay = payload => ({
  type: CHECKOUT_LINE_PAY,
  payload,
});

export const checkoutLinePaySuccess = payload => ({
  type: CHECKOUT_LINE_PAY_SUCCESS,
  payload,
});

export const checkoutLinePayFailure = errorCode => ({
  type: CHECKOUT_LINE_PAY_FAILURE,
  payload: {
    errorCode,
  },
});

const INIT_STATE = {
  status: loadingState.EMPTY,
  errorCode: loadingState.EMPTY,
  paymentUrl: null,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_LINE_PAY:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case REQUEST_LINE_PAY_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        paymentUrl: action.payload.paymentUrl,
      };
    case REQUEST_LINE_PAY_FAILURE:
      return {
        ...state,
        status: loadingState.ERROR,
      };
    case CHECKOUT_LINE_PAY:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case CHECKOUT_LINE_PAY_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
      };
    case CHECKOUT_LINE_PAY_FAILURE:
      return {
        ...state,
        status: loadingState.ERROR,
      };
    default:
      return state;
  }
};

export const getPaymentUrl = state => state.checkoutLinePay.paymentUrl;
export const getCheckoutLinePayStatus = state => state.checkoutLinePay.status;

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/purchase/checkoutLinePay.js